import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';

export const EXTRACTION_ACCURACY_PATH = EvidencePlatformSidebarAppID.extractionAccuracy;

// Extraction Accuracy Getters
export const getExtractionAccuracyPath = () => {
  return `/${EXTRACTION_ACCURACY_PATH}`;
};
